import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import {
  IconButton,
  Box,
  Typography,
  Button,
  Link,
  Popover,
  makeStyles
} from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircleOutlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { logout } from '../auth/authSlice';
import { selectUser } from './userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  menu: {
    padding: theme.spacing(3, 2),
    minWidth: '300px'
  },
}));

const UserMenu = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [ anchorEl, setAnchorEl ] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const { info } = useSelector(selectUser);

  const { withButton, ...rest } = props;

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    handleClose();
  }

  const renderContent = () => {
    return (
      <>
        <Typography variant="body2" component="div">
          <Box fontWeight="bold">{info.firstName}</Box>
          {info.username}
        </Typography>
        <p><Link component={RouterLink} to="/pih/settings" onClick={handleClose}>{t('nav:settings')}</Link></p>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ExitToAppIcon />}
          onClick={handleLogout}
          disableElevation
        >
          {t('nav:logout')}
        </Button>
      </>
    )
  }

  if(withButton) {

    return (
      <div {...rest}>
        <IconButton
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <Popover
          id="menu-appbar"
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div className={classes.menu}>
            {renderContent()}
          </div>
        </Popover>
      </div>
    );

  } else {
    return renderContent();
  }
};

UserMenu.propTypes = {
  withButton: PropTypes.bool,
};

export default UserMenu;
